import { Injectable } from '@angular/core';
import { DevicePositionHistory } from '../models/DevicePositionHistory';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiProvider } from '../providers/api.provider';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DevicepositionhistoryService {

  private currentDevicePositionHistorySubject: BehaviorSubject<DevicePositionHistory[]>;
  public currentDevicePositionHistory: Observable<DevicePositionHistory[]>;
  public RouteID:number = 0;
  public RouteDate: Date;
  constructor(private apiProvider: ApiProvider) { }

  public get currentDevicePositionHistoryValue(): DevicePositionHistory[] {
    return this.currentDevicePositionHistorySubject.value;
  }

  async initialiseDevicepositionhistory() {
    await this.apiProvider.DevicePositionHistories(this.RouteID, this.RouteDate).subscribe((Devicepositionhistories: DevicePositionHistory[]) => {
      this.currentDevicePositionHistorySubject = new BehaviorSubject<DevicePositionHistory[]>(Devicepositionhistories);
      this.currentDevicePositionHistory = this.currentDevicePositionHistorySubject.asObservable();
    }, (err: HttpErrorResponse) => {
      this.currentDevicePositionHistorySubject.next(null);
    });
  }
}
